module.exports = __webpack_public_path__ + "static/mucoff-land-672e200c06564fc96a4a0448c94ac5e2.jpg";